<template>
  <v-bottom-sheet
    v-if="isMobile"
    v-model="isVisible"
    data-qa="service-details-modal"
    scrollable
  >
    <v-card tile>
      <div class="elevation-4 px-4 pb-4 pt-6">
        <div
          v-if="title"
          class="text-h6 text--text"
          :class="{ 'mb-2': isDoctorWorkAtLpu }"
        >
          {{ title }}
        </div>
        <div
          v-if="isDoctorWorkAtLpu"
          class="text-body-2 text-secondary--text"
          data-qa="service-details-content_is_doctor_work_at_lpu"
        >
          {{ t('Комплекс услуг указан врачом. Цена может быть не окончательной.', optionsLang) }}
        </div>
      </div>
      <div class="py-6 px-4 overflow-y-auto">
        <slot />
      </div>
      <div class="elevation-8 pa-2">
        <v-btn
          color="bg-primary"
          class="primary--text elevation-0 w-100"
          @click="close"
        >
          {{ t('Понятно', optionsLang) }}
        </v-btn>
      </div>
    </v-card>
  </v-bottom-sheet>
  <CoreDialog
    v-else
    v-model="isVisible"
    data-qa="service-details-modal"
    :title="title"
    min-height="100px"
    size="lg"
    divider
  >
    <template #prependBtn="{ btnProps }">
      <v-btn
        v-bind="btnProps"
        @click="close"
      >
        <span class="ui-icon-close-not-a-circle" />
      </v-btn>
    </template>
    <div
      v-if="isDoctorWorkAtLpu"
      class="text-body-2 text-secondary--text mb-5"
      data-qa="service-details-content_is_doctor_work_at_lpu"
    >
      {{ t('Комплекс услуг указан врачом. Цена может быть не окончательной.', optionsLang) }}
    </div>
    <slot />
    <template #actions>
      <v-btn
        data-qa="modal-actions-btn-close"
        color="primary"
        text
        @click="close"
      >
        {{ t('Закрыть', optionsLang) }}
      </v-btn>
    </template>
  </CoreDialog>
</template>

<script lang="ts" setup>
import I18NextVue from 'i18next'
import { computed } from 'vue'
import getFormattedPrice from 'www/utils/get/getFormattedPrice'
import CoreDialog from 'src/core/CoreDialog/CoreDialog.vue'
import type { ApiDoctorCaseServicesResponseGet } from 'www/vue_components/common/DoctorCases/api/apiDoctorCaseServices.types'

const props = defineProps<{
  value: boolean
  totalPrice: number
  isDoctorWorkAtLpu: ApiDoctorCaseServicesResponseGet['is_doctor_work_at_lpu']
}>()

type Emits = {
  (_e: 'input', _value: boolean): void
}

const emit = defineEmits<Emits>()

const { t, language } = I18NextVue
const optionsLang = { ns: language }

const isMobile = window.MOBILE_VERSION
const title = computed(() => (props.totalPrice ? `${t('Услуги на', optionsLang)} ${getFormattedPrice(props.totalPrice)}` : ''))
const isVisible = computed({
  get() {
    return props.value
  },
  set(value: boolean) {
    emit('input', value)
  },
})

function close() {
  isVisible.value = false
}
</script>
